import { loadRemoteModule } from '@angular-architects/module-federation';
import { AfterViewInit, Component, Inject, Renderer2 } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'edc-wrapper',
  templateUrl: './edc-wrapper.component.html',
})
export class EdcWrapperComponent implements AfterViewInit {
  constructor(
    private renderer: Renderer2,
    public dialogRef: MatDialogRef<EdcWrapperComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    //intentionally blank
  }

  ngAfterViewInit(): void {
    this.processPopup();
  }

  async processPopup() {
    let cdnUrl = (window as any).pershingAppSettings.elementConfig[
      'edelivery-app'
    ]['url'];
    const mRef = await loadRemoteModule({
      type: 'module',
      remoteEntry: cdnUrl,
      exposedModule: './edeliveryApp',
    }).then((m) => console.log(m));
  }
}
